import PostLoginPresenter from "@adapters/features/PostLogin/Presenters/PostLoginPresenter";
export default (useCases, actions) => {
    return {
        postLogin: new PostLoginPresenter(useCases.postLogin, actions.postLogin, useCases.quoteStream),
    };
};
